import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setSchoolsList } from "src/reducers/schools";
import { dummySchools } from "src/constants/dummySchools";

// ✅ SAFE ID EXTRACTOR
const extractId = (input: any): string | null => {
  if (!input) return null;
  if (typeof input === "string") return input;
  if (typeof input === "object" && input.id) return input.id;
  return null;
};

// ✅ GET SCHOOLS
export const getSchoolsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(`/api/v1/admin/schools?${query}`);
      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setSchoolsList(dummySchools));
        return dummySchools;
      }

      // ✅ FORMAT FOR UI
      const formattedData = {
        data: apiResponse.data.data.map((item: any) => ({
          id: item.id,
          name: item.name,
          address: item.address,
          pincode: item.pincode,
          landmark: item.landmark,
          latitude: item.latitude,
          longitude: item.longitude,

          // 🔥 UI EXPECTS THESE KEYS
          phone: item.contactPhone,
          email: item.contactEmail,
          status: item.isActive ? 1 : 0,
          createdOn: item.createdAt,
        })),
        total: apiResponse.data.total,
      };

      dispatch(setSchoolsList(formattedData));
      return formattedData;
    } catch {
      dispatch(setSchoolsList(dummySchools));
      return dummySchools;
    }
  };

// ✅ ADD SCHOOL
export const addSchoolAction: any =
  (payload) => async () => {
    try {
      const formattedPayload = {
        name: payload.name,
        address: payload.address,
        pincode: payload.pincode,
        landmark: payload.landmark,
        latitude: payload.latitude,
        longitude: payload.longitude,
        contactPhone: payload.phone,
        contactEmail: payload.email,
      };

      const res = await instance.post(
        `/api/v1/admin/schools`,
        formattedPayload
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ TOGGLE STATUS
export const updateSchoolStatusAction: any =
  (input: any) => async () => {
    try {
      const id =
        typeof input === "object" ? input.id : extractId(input);

      if (!id) throw new Error("Invalid school id");

      const res = await instance.put(
        `/api/v1/admin/schools/${id}/toggle-status`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DELETE SCHOOL
export const deleteSchoolAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);

      if (!id) throw new Error("Invalid school id");

      const res = await instance.delete(
        `/api/v1/admin/deleteSchool/${id}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };